import { Typography } from '@/shared/ui/Typography/Typography';

import StairsIcon from "@/assets/icons/stairs.svg?react";
import ScreenIcon from "@/assets/icons/screenSize.svg?react";
import LocationIcon from "@/assets/icons/location.svg?react";
import BuildingIcon from "@/assets/icons/building.svg?react";
import { buildingType } from '@/entities/knowledge/model/types';

type SpecsSectionProp = {
  building?: buildingType
}

export function SpecsSection({ building }: SpecsSectionProp) {

  if (!building)
    return null

  return (
    <section className='w-full pt-[20px] pb-[32px] md:py-[32px]'>
      <div className='container px-[10px] md:px-[32px] 2xl:px-[180px] 3xl:px-[290px] flex flex-col gap-[20px]'>
        <div className="flex flex-col gap-[16px] md:flex-row md:justify-between">
          <Typography className='text-[24px] md:text-[26px] xl:text-[32px] uppercase leading-[0.98em] font-semibold'>
            Ключевые характеристики
          </Typography>

          <Typography className='text-[14px] font-[400] xl:text-[16px] md:w-[326px] xl:w-[418px]'>
            Вся важная информация об объекте — от площадей и отделки до расположения и инфраструктуры
          </Typography>
        </div>

        <div className="flex flex-col justify-center gap-[8px] md:flex-row xl:gap-[20px]">
          <div className="flex flex-col gap-[12px] justify-center py-[20px] px-[16px] lg:px-[20px] bg-[#E9E9E9] rounded-[20px] md:w-auto md:flex-1">

            <Typography className="text-[1rem] font-[600] xl:text-[20px] leading-none">
              Офисные помещения
            </Typography>
            <Typography className='text-[14px] font-[400] leading-none text-[#00000080]'>
              Площадь офисов: от {building.offices.areaRange.from} {building.offices.areaRange.unit} до {building.offices.areaRange.to} {building.offices.areaRange.unit}
            </Typography >
            <Typography className='text-[14px] font-[400] leading-none text-[#00000080]'>
              Высота потолков: от {building.offices.ceilingHeight}
            </Typography>
            <Typography className='text-[14px] font-[400] leading-none text-[#00000080]'>
              Отделка: от {building.offices.finish}
            </Typography>

          </div>

          <div className="flex flex-col gap-[12px] justify-center py-[20px] px-[16px] xl:px-[20px] bg-[#E9E9E9] rounded-[20px] md:w-auto md:flex-1">

            <Typography className="text-[1rem] font-[600] xl:text-[20px] leading-none">
              Торговые площади
            </Typography>
            <Typography className='text-[14px] font-[400] leading-none text-[#00000080]'>
              Общая площадь ритейла: {building.retail.area.value} {building.retail.area.unit}
            </Typography>
            <Typography className='text-[14px] font-[400] leading-none text-[#00000080]'>
              Стоимость от: {building.retail.price.value} {building.retail.area.unit}
            </Typography>
            <Typography className='text-[14px] font-[400] leading-none text-[#00000080]'>
              Сдача: {building.retail.deliveryDate}
            </Typography>
          </div>

          <div className="flex flex-col gap-[12px] justify-center py-[20px] px-[16px] xl:px-[20px] bg-[#E9E9E9] rounded-[20px] md:w-auto md:flex-1">

            <Typography className="text-[1rem] font-[600] xl:text-[20px] leading-none">
              Транспортная доступность
            </Typography>
            <Typography className='text-[14px] font-[400] leading-none text-[#00000080]'>
              Станция метро: {building.transport.metro}
            </Typography>
            <Typography className='text-[14px] font-[400] leading-none text-[#00000080]'>
              Паркинг: {building.transport.parking}
            </Typography>
            <Typography className='text-[14px] font-[400] leading-none text-[#00000080]'>
              Класс БЦ: {building.class.grade}
            </Typography>
          </div>
        </div>

        <div className='flex flex-row gap-[8px] lg:gap-[20px]'>

            <div className='hidden md:block flex-1 overflow-hidden bg-center bg-cover rounded-xl'
              style={{ backgroundImage: `url(${building.specsFirstImageUrl || "/images/knowledge_default_bg.png"})` }}
            />

            <div className="flex flex-col gap-[8px] lg:gap-[20px] w-full md:w-[321px] lg:w-[457px]">
              <img
                src={building.specsSecondImageUrl || "/images/knowledge_default_bg.png"}
                alt=""
                className="w-full h-[160px] lg:h-[200px] object-cover rounded-[20px]"
              />
              <div className="w-full gap-[20px] grid grid-cols-2 pb-[20px] border-b-[1px] border-black">

                <div className="flex flex-col gap-[10px] items-center">
                  <LocationIcon className="h-[40px] w-[34px]" />
                  <Typography className='text-[12px] font-[300] lg:text-[16px]'>
                    {building.address}
                  </Typography>
                </div>

                <div className="flex flex-col gap-[10px] items-center">
                  <ScreenIcon className="w-[40px] h-[33px]" />
                  <Typography className='text-[12px] font-[300] lg:text-[16px]'>
                    Общая площадь: {building.totalArea.value} {building.totalArea.unit}
                  </Typography>
                </div>

                <div className="flex flex-col gap-[10px] items-center">
                  <StairsIcon className="h-[40px] w-[35px]" />
                  <Typography className='text-[12px] font-[300] lg:text-[16px]'>
                    {building.floors} этажей
                  </Typography>
                </div>

                <div className="flex flex-col gap-[10px] items-center">
                  <BuildingIcon className="w-[40px] h-[40px]" />
                  <Typography className='text-[12px] font-[300] lg:text-[16px]'>
                    Застройщик: {building.developer}
                  </Typography>
                </div>

              </div>
            </div>
        </div>
      </div>
    </section>
  );
}